import React from 'react';
import Icon from './Icon';

const DrawPointIcon = (props) => (
    <Icon {...props} viewBox="0 0 1024 1024">
        <path d="M406.055 511.941c0 0.004 0 0.007 0 0.008 0 58.479 47.407 105.886 105.886 105.886 58.478 0 105.886-47.407 105.886-105.886 0-0.004 0-0.008 0-0.008 0-0.003 0-0.007 0-0.007 0-58.478-47.407-105.886-105.886-105.886-58.478 0-105.886 47.407-105.886 105.886 0 0.004 0 0.007 0 0.007zM511.941 859.615c-191.564 0-347.555-155.992-347.555-347.674s155.992-347.555 347.555-347.555 347.555 155.992 347.555 347.555-155.874 347.674-347.555 347.674zM511.941 235.292c-152.565 0-276.65 124.085-276.65 276.65s124.085 276.65 276.65 276.65 276.65-124.085 276.65-276.65-124.085-276.65-276.65-276.65z" fill="currentColor" />
    </Icon>
);

export default DrawPointIcon;